/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosDailyAverageTransactionInfo } from '../models/AptosDailyAverageTransactionInfo';
import type { AptosTrxBalanceChangeListInfo } from '../models/AptosTrxBalanceChangeListInfo';
import type { AptosTrxBalanceChangeListRequest } from '../models/AptosTrxBalanceChangeListRequest';
import type { AptosTrxChangeListRequest } from '../models/AptosTrxChangeListRequest';
import type { AptosTrxCoinPopularListInfo } from '../models/AptosTrxCoinPopularListInfo';
import type { AptosTrxCoinSearchInfo } from '../models/AptosTrxCoinSearchInfo';
import type { AptosTrxCoinSearchRequest } from '../models/AptosTrxCoinSearchRequest';
import type { AptosTrxCsvDownloadRequest } from '../models/AptosTrxCsvDownloadRequest';
import type { AptosTrxDailyAvgCreatedRequest } from '../models/AptosTrxDailyAvgCreatedRequest';
import type { AptosTrxDetailRequest } from '../models/AptosTrxDetailRequest';
import type { AptosTrxEventInfo } from '../models/AptosTrxEventInfo';
import type { AptosTrxEventListRequest } from '../models/AptosTrxEventListRequest';
import type { AptosTrxFunctionSearchInfo } from '../models/AptosTrxFunctionSearchInfo';
import type { AptosTrxFunctionSearchRequest } from '../models/AptosTrxFunctionSearchRequest';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';
import type { AptosTrxListRequest } from '../models/AptosTrxListRequest';
import type { AptosTrxOverviewInfo } from '../models/AptosTrxOverviewInfo';
import type { AptosTrxPayloadInfo } from '../models/AptosTrxPayloadInfo';
import type { AptosTrxPayloadRequest } from '../models/AptosTrxPayloadRequest';
import type { AptosTrxPopularCoinListRequest } from '../models/AptosTrxPopularCoinListRequest';
import type { AptosTrxScrollListInfo } from '../models/AptosTrxScrollListInfo';
import type { AptosTrxScrollListRequest } from '../models/AptosTrxScrollListRequest';
import type { AptosTrxSummaryInfo } from '../models/AptosTrxSummaryInfo';
import type { AptosTrxSummaryListRequest } from '../models/AptosTrxSummaryListRequest';
import type { AptosTrxUawCountRequest } from '../models/AptosTrxUawCountRequest';
import type { AptosUawTrxCountChartListInfo } from '../models/AptosUawTrxCountChartListInfo';
import type { BabylonBlockEventListInfo } from '../models/BabylonBlockEventListInfo';
import type { BabylonTrxCsvDownloadRequest } from '../models/BabylonTrxCsvDownloadRequest';
import type { BabylonTrxDetailInfo } from '../models/BabylonTrxDetailInfo';
import type { BabylonTrxDetailRequest } from '../models/BabylonTrxDetailRequest';
import type { BabylonTrxEventListRequest } from '../models/BabylonTrxEventListRequest';
import type { BabylonTrxListInfo } from '../models/BabylonTrxListInfo';
import type { BabylonTrxListRequest } from '../models/BabylonTrxListRequest';
import type { BabylonTrxLogEventListInfo } from '../models/BabylonTrxLogEventListInfo';
import type { BabylonTrxLogListInfo } from '../models/BabylonTrxLogListInfo';
import type { BabylonTrxLogListRequest } from '../models/BabylonTrxLogListRequest';
import type { BabylonTrxMessageListRequest } from '../models/BabylonTrxMessageListRequest';
import type { BabylonTrxScrollRequest } from '../models/BabylonTrxScrollRequest';
import type { EvmABIFunctionParamRequest } from '../models/EvmABIFunctionParamRequest';
import type { EvmABIMethodParamInfo } from '../models/EvmABIMethodParamInfo';
import type { EvmInternalTraceGroupInfo } from '../models/EvmInternalTraceGroupInfo';
import type { EvmInternalTrxGroupListInfo } from '../models/EvmInternalTrxGroupListInfo';
import type { EvmInternalTrxListRequest } from '../models/EvmInternalTrxListRequest';
import type { EvmInternalTrxTraceRequest } from '../models/EvmInternalTrxTraceRequest';
import type { EvmLogsInfo } from '../models/EvmLogsInfo';
import type { EvmPendingTrxListRequest } from '../models/EvmPendingTrxListRequest';
import type { EvmTrxDetailInfo } from '../models/EvmTrxDetailInfo';
import type { EvmTrxDetailRequest } from '../models/EvmTrxDetailRequest';
import type { EvmTrxListInfo } from '../models/EvmTrxListInfo';
import type { EvmTrxListRequest } from '../models/EvmTrxListRequest';
import type { EvmTrxLogListRequest } from '../models/EvmTrxLogListRequest';
import type { EvmTrxPendingListInfo } from '../models/EvmTrxPendingListInfo';
import type { EvmTrxScrollRequest } from '../models/EvmTrxScrollRequest';
import type { EvmTrxSummaryInfo } from '../models/EvmTrxSummaryInfo';
import type { EvmTrxSummaryListRequest } from '../models/EvmTrxSummaryListRequest';
import type { HumanityInternalTrxGroupListInfo } from '../models/HumanityInternalTrxGroupListInfo';
import type { HumanityInternalTrxListRequest } from '../models/HumanityInternalTrxListRequest';
import type { HumanityInternalTrxNestedListInfo } from '../models/HumanityInternalTrxNestedListInfo';
import type { HumanityInternalTrxTraceRequest } from '../models/HumanityInternalTrxTraceRequest';
import type { HumanityTrxDetailInfo } from '../models/HumanityTrxDetailInfo';
import type { HumanityTrxDetailRequest } from '../models/HumanityTrxDetailRequest';
import type { HumanityTrxListInfo } from '../models/HumanityTrxListInfo';
import type { HumanityTrxListRequest } from '../models/HumanityTrxListRequest';
import type { HumanityTrxScrollRequest } from '../models/HumanityTrxScrollRequest';
import type { HumanityTrxSummaryInfo } from '../models/HumanityTrxSummaryInfo';
import type { HumanityTrxSummaryListRequest } from '../models/HumanityTrxSummaryListRequest';
import type { KiteInternalTrxGroupListInfo } from '../models/KiteInternalTrxGroupListInfo';
import type { KiteInternalTrxListRequest } from '../models/KiteInternalTrxListRequest';
import type { KiteInternalTrxNestedListInfo } from '../models/KiteInternalTrxNestedListInfo';
import type { KiteInternalTrxTraceRequest } from '../models/KiteInternalTrxTraceRequest';
import type { KiteTrxDetailInfo } from '../models/KiteTrxDetailInfo';
import type { KiteTrxDetailRequest } from '../models/KiteTrxDetailRequest';
import type { KiteTrxListInfo } from '../models/KiteTrxListInfo';
import type { KiteTrxListRequest } from '../models/KiteTrxListRequest';
import type { KiteTrxNftTransferListInfo } from '../models/KiteTrxNftTransferListInfo';
import type { KiteTrxNftTransferListRequest } from '../models/KiteTrxNftTransferListRequest';
import type { KiteTrxScrollRequest } from '../models/KiteTrxScrollRequest';
import type { KiteTrxSummaryInfo } from '../models/KiteTrxSummaryInfo';
import type { KiteTrxSummaryListRequest } from '../models/KiteTrxSummaryListRequest';
import type { KiteTrxTokenTransferListInfo } from '../models/KiteTrxTokenTransferListInfo';
import type { KiteTrxTokenTransferListRequest } from '../models/KiteTrxTokenTransferListRequest';
import type { SomniaInternalTrxGroupListInfo } from '../models/SomniaInternalTrxGroupListInfo';
import type { SomniaInternalTrxListRequest } from '../models/SomniaInternalTrxListRequest';
import type { SomniaInternalTrxNestedListInfo } from '../models/SomniaInternalTrxNestedListInfo';
import type { SomniaInternalTrxScrollRequest } from '../models/SomniaInternalTrxScrollRequest';
import type { SomniaInternalTrxTraceRequest } from '../models/SomniaInternalTrxTraceRequest';
import type { SomniaLogsInfo } from '../models/SomniaLogsInfo';
import type { SomniaTrxDetailInfo } from '../models/SomniaTrxDetailInfo';
import type { SomniaTrxDetailRequest } from '../models/SomniaTrxDetailRequest';
import type { SomniaTrxListInfo } from '../models/SomniaTrxListInfo';
import type { SomniaTrxListRequest } from '../models/SomniaTrxListRequest';
import type { SomniaTrxLogListRequest } from '../models/SomniaTrxLogListRequest';
import type { SomniaTrxNftTransferListInfo } from '../models/SomniaTrxNftTransferListInfo';
import type { SomniaTrxNftTransferListRequest } from '../models/SomniaTrxNftTransferListRequest';
import type { SomniaTrxScrollRequest } from '../models/SomniaTrxScrollRequest';
import type { SomniaTrxSummaryInfo } from '../models/SomniaTrxSummaryInfo';
import type { SomniaTrxSummaryListRequest } from '../models/SomniaTrxSummaryListRequest';
import type { SomniaTrxTokenTransferListInfo } from '../models/SomniaTrxTokenTransferListInfo';
import type { SomniaTrxTokenTransferListRequest } from '../models/SomniaTrxTokenTransferListRequest';
import type { ZerogInternalTrxGroupListInfo } from '../models/ZerogInternalTrxGroupListInfo';
import type { ZerogInternalTrxListRequest } from '../models/ZerogInternalTrxListRequest';
import type { ZerogInternalTrxNestedListInfo } from '../models/ZerogInternalTrxNestedListInfo';
import type { ZerogInternalTrxTraceRequest } from '../models/ZerogInternalTrxTraceRequest';
import type { ZerogLogsInfo } from '../models/ZerogLogsInfo';
import type { ZerogTrxDetailInfo } from '../models/ZerogTrxDetailInfo';
import type { ZerogTrxDetailRequest } from '../models/ZerogTrxDetailRequest';
import type { ZerogTrxListInfo } from '../models/ZerogTrxListInfo';
import type { ZerogTrxListRequest } from '../models/ZerogTrxListRequest';
import type { ZerogTrxLogListRequest } from '../models/ZerogTrxLogListRequest';
import type { ZerogTrxScrollRequest } from '../models/ZerogTrxScrollRequest';
import type { ZerogTrxSummaryInfo } from '../models/ZerogTrxSummaryInfo';
import type { ZerogTrxSummaryListRequest } from '../models/ZerogTrxSummaryListRequest';
import type { ZerogTrxTokenTransferListInfo } from '../models/ZerogTrxTokenTransferListInfo';
import type { ZerogTrxTokenTransferListRequest } from '../models/ZerogTrxTokenTransferListRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TrxControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxDetail({
        requestBody,
    }: {
        requestBody: (AptosTrxDetailRequest | EvmTrxDetailRequest | HumanityTrxDetailRequest | KiteTrxDetailRequest | BabylonTrxDetailRequest | SomniaTrxDetailRequest | ZerogTrxDetailRequest),
    }): CancelablePromise<(AptosTrxOverviewInfo | EvmTrxDetailInfo | HumanityTrxDetailInfo | KiteTrxDetailInfo | BabylonTrxDetailInfo | SomniaTrxDetailInfo | ZerogTrxDetailInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getUawTrxCount({
        requestBody,
    }: {
        requestBody: AptosTrxUawCountRequest,
    }): CancelablePromise<AptosUawTrxCountChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/uaw/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTokenTransferList({
        requestBody,
    }: {
        requestBody: (SomniaTrxTokenTransferListRequest | KiteTrxTokenTransferListRequest | ZerogTrxTokenTransferListRequest),
    }): CancelablePromise<(SomniaTrxTokenTransferListInfo | KiteTrxTokenTransferListInfo | ZerogTrxTokenTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/token/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxSummaryList({
        requestBody,
    }: {
        requestBody: (AptosTrxSummaryListRequest | EvmTrxSummaryListRequest | HumanityTrxSummaryListRequest | KiteTrxSummaryListRequest | SomniaTrxSummaryListRequest | ZerogTrxSummaryListRequest),
    }): CancelablePromise<Array<(AptosTrxSummaryInfo | EvmTrxSummaryInfo | HumanityTrxSummaryInfo | KiteTrxSummaryInfo | SomniaTrxSummaryInfo | ZerogTrxSummaryInfo)>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxScrollList({
        requestBody,
    }: {
        requestBody: (AptosTrxScrollListRequest | EvmTrxScrollRequest | BabylonTrxScrollRequest | HumanityTrxScrollRequest | KiteTrxScrollRequest | SomniaTrxScrollRequest | ZerogTrxScrollRequest),
    }): CancelablePromise<(AptosTrxScrollListInfo | EvmTrxListInfo | BabylonTrxListInfo | HumanityTrxListInfo | KiteTrxListInfo | SomniaTrxListInfo | ZerogTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/scroll/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getPendingTrxList({
        requestBody,
    }: {
        requestBody: EvmPendingTrxListRequest,
    }): CancelablePromise<EvmTrxPendingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/pending/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getPayloadList({
        requestBody,
    }: {
        requestBody: AptosTrxPayloadRequest,
    }): CancelablePromise<AptosTrxPayloadInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/payload',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNftTransferList({
        requestBody,
    }: {
        requestBody: (SomniaTrxNftTransferListRequest | KiteTrxNftTransferListRequest),
    }): CancelablePromise<(SomniaTrxNftTransferListInfo | KiteTrxNftTransferListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/nft/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMessageList({
        requestBody,
    }: {
        requestBody: BabylonTrxMessageListRequest,
    }): CancelablePromise<BabylonTrxLogEventListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/log/message/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getLogList({
        requestBody,
    }: {
        requestBody: (EvmTrxLogListRequest | SomniaTrxLogListRequest | ZerogTrxLogListRequest),
    }): CancelablePromise<Array<(EvmLogsInfo | SomniaLogsInfo | ZerogLogsInfo)>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/log/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getLogListWithListInfo({
        requestBody,
    }: {
        requestBody: BabylonTrxLogListRequest,
    }): CancelablePromise<Array<BabylonTrxLogListInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/log/list/babylon',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCosmosEventList({
        requestBody,
    }: {
        requestBody: BabylonTrxEventListRequest,
    }): CancelablePromise<BabylonTrxLogEventListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/log/event/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxList({
        requestBody,
    }: {
        requestBody: (AptosTrxListRequest | EvmTrxListRequest | HumanityTrxListRequest | KiteTrxListRequest | BabylonTrxListRequest | SomniaTrxListRequest | ZerogTrxListRequest),
    }): CancelablePromise<(AptosTrxListInfo | EvmTrxListInfo | HumanityTrxListInfo | KiteTrxListInfo | BabylonTrxListInfo | SomniaTrxListInfo | ZerogTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public downloadCsv({
        requestBody,
    }: {
        requestBody: (AptosTrxCsvDownloadRequest | BabylonTrxCsvDownloadRequest),
    }): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/list/csv',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getInternalTrace({
        requestBody,
    }: {
        requestBody: (HumanityInternalTrxTraceRequest | KiteInternalTrxTraceRequest | SomniaInternalTrxTraceRequest | ZerogInternalTrxTraceRequest),
    }): CancelablePromise<(HumanityInternalTrxNestedListInfo | KiteInternalTrxNestedListInfo | SomniaInternalTrxNestedListInfo | ZerogInternalTrxNestedListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/internal/trace',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getInternalTraceList({
        requestBody,
    }: {
        requestBody: EvmInternalTrxTraceRequest,
    }): CancelablePromise<Array<EvmInternalTraceGroupInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/internal/trace/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getInternalTrxScrollList({
        requestBody,
    }: {
        requestBody: SomniaInternalTrxScrollRequest,
    }): CancelablePromise<SomniaInternalTrxGroupListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/internal/scroll/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getInternalTrxList({
        requestBody,
    }: {
        requestBody: (EvmInternalTrxListRequest | HumanityInternalTrxListRequest | KiteInternalTrxListRequest | SomniaInternalTrxListRequest | ZerogInternalTrxListRequest),
    }): CancelablePromise<(EvmInternalTrxGroupListInfo | HumanityInternalTrxGroupListInfo | KiteInternalTrxGroupListInfo | SomniaInternalTrxGroupListInfo | ZerogInternalTrxGroupListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/internal/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getFunctionFilterSearch({
        requestBody,
    }: {
        requestBody: AptosTrxFunctionSearchRequest,
    }): CancelablePromise<AptosTrxFunctionSearchInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/function/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getEventList({
        requestBody,
    }: {
        requestBody: AptosTrxEventListRequest,
    }): CancelablePromise<Array<AptosTrxEventInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/event/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getEventListWithListInfo({
        requestBody,
    }: {
        requestBody: BabylonTrxEventListRequest,
    }): CancelablePromise<Array<BabylonBlockEventListInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/event/list/babylon',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getDailyAverageCreated({
        requestBody,
    }: {
        requestBody: AptosTrxDailyAvgCreatedRequest,
    }): CancelablePromise<AptosDailyAverageTransactionInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/daily',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinFilterSearch({
        requestBody,
    }: {
        requestBody: AptosTrxCoinSearchRequest,
    }): CancelablePromise<AptosTrxCoinSearchInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/coin/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinPopularList({
        requestBody,
    }: {
        requestBody: AptosTrxPopularCoinListRequest,
    }): CancelablePromise<AptosTrxCoinPopularListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/coin/popular',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getChangeList({
        requestBody,
    }: {
        requestBody: AptosTrxChangeListRequest,
    }): CancelablePromise<Array<Record<string, Record<string, any>>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/change/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxBalanceChangeList({
        requestBody,
    }: {
        requestBody: AptosTrxBalanceChangeListRequest,
    }): CancelablePromise<AptosTrxBalanceChangeListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/balance/change/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getEvmAbiFunctionParamList({
        requestBody,
    }: {
        requestBody: EvmABIFunctionParamRequest,
    }): CancelablePromise<EvmABIMethodParamInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/transaction/abi/param/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
